module.exports = __webpack_public_path__ + "img/s6Bg.8246bf81.webp";